import { useEffect, useRef } from 'react';
import { silentRefresh } from '../lib/session';

// Background data synchronisation: polls on an interval (only while the tab/app
// is visible) and re-fetches immediately when the app is re-opened or focused.
// Also slides the auth session so users stay logged in.
export function useAutoRefresh(callback, { interval = 45000, withSession = true } = {}) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    let timer = null;
    const run = () => {
      if (document.visibilityState !== 'visible') return;
      if (withSession) silentRefresh();
      try { cbRef.current && cbRef.current(); } catch (e) { /* silent */ }
    };
    const start = () => { stop(); timer = setInterval(run, interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') { run(); start(); } else { stop(); }
    };
    const onFocus = () => run();

    start();
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocus);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocus);
    };
  }, [interval, withSession]);
}
